/** State-license chips, showing the first `max` then a ghost "+N". */
export function LwLicenseBadges({ items, max = 4 }: { items: string[]; max?: number }) {
  return (
    <div className="lic">
      {items.slice(0, max).map((c) => (
        <span className="lic-badge" key={c}>
          {c}
        </span>
      ))}
      {items.length > max && <span className="lic-badge more">+{items.length - max}</span>}
    </div>
  );
}
